
function HeaderComponent() {
  return (
     <header className="d-lg-block d-none">
     <div className="container-fluid">
       {/* row start */}
       <div className="row">
         {/* single item start */}
         <div className="col-lg-4 align-self-center">
           <div className="right-item">
             <a href="/"><img src="/static/img/main-logo.png" alt="img" className="img-fluid" /></a>
           </div>
         </div>
         {/* single item end */}
         {/* single item start */}
         <div className="col-lg-8  text-center align-self-center">
           <div className="left-header d-flex justify-content-end">
             <div className="hditem1">
               <img src="/static/img/logo2.png" alt="img" className="img-fluid" />
               <a target="_blank" href="https://tatweertransit.walaplus.com">العروض</a>
             </div>
             <div className="hditem2">
               <img src="/static/img/logo1.png" alt="img" className="img-fluid" />
               <a target="_blank" href="https://sahel.tatweertransit.com">الدخول لنظام سهل</a>
             </div>
             <div className="hditem1">
             </div>
             <div className="hditem2">
               <img src="/static/img/Maan_color.png" alt="img" className="img-fluid" style={{ marginBottom: "10px" }} />
               <a target="_blank" href="https://maan.tatweer.sa/ar">الدخول لنظام معاً</a>
             </div>
           </div>
         </div>
         {/* single item end */}
       </div>
       {/* row end*/}
     </div>
   </header>
  );
}

export default HeaderComponent;


